module.exports = __webpack_public_path__ + "img/avatar7.ddaafe23.png";